import {
    IBuscarContaLink,
    IListarPerguntasERespostasLink,
    IResponderPesquisaSatisfacaoLink,
} from "../../../Interfaces/Geral/ResponderFormularioLink/ResponderFormularioLinkInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function BuscarContaLinkService(
    guid: string,
    idOrganizacao: string
) {
    return Service(
        Axios.get<IBuscarContaLink>(
            `/home/responderformulario/buscarconta?guid=${guid}&idOrganizacao=${idOrganizacao}`
        )
    );
}

export async function ListarFormularioPerguntaRespostasService(
    idFormulario: string,
    idOrganizacao: string
) {
    return Service(
        Axios.get<IListarPerguntasERespostasLink>(
            `/home/responderformulario/listarformularioperguntarespostas?idFormulario=${parseInt(idFormulario, 10)}&idOrganizacao=${idOrganizacao}`
        )
    );
}

export async function ResponderPesquisaSatisfacaoLinkService(
    idCaso: number,
    guid: string,
    idOrganizacao: string,
    data: IResponderPesquisaSatisfacaoLink
) {
    return Service(
        Axios.post(
            `/home/responderformulario/responderpesquisadesatisfacao?idCaso=${idCaso}&idOrganizacao=${idOrganizacao}&guid=${guid}`,
            data
        )
    );
}
